/**
 * Formats a duration in seconds to a string in the format "m:ss"
 * @param seconds - The duration in seconds
 * @returns A formatted string in the format "m:ss"
 */
export const formatDuration = (seconds: number): string => {
  if (!isFinite(seconds) || seconds < 0) return "0:00";
  
  const mins = Math.floor(seconds / 60);
  const secs = Math.floor(seconds % 60);
  return `${mins}:${secs.toString().padStart(2, '0')}`;
}; 